import {defineStore} from "pinia";
import {ref} from "vue";
import {Notification} from "@t/meta/Notification.ts";

const RINGING_HIDDEN_KEY = "ringingNotificationsHidden";

function getHiddenFlag():boolean {
	let item = sessionStorage.getItem(RINGING_HIDDEN_KEY);
	return item != null;
}

function setHiddenFlag(flag:boolean):void {
	if (flag) sessionStorage.setItem(RINGING_HIDDEN_KEY, "1");
	else sessionStorage.removeItem(RINGING_HIDDEN_KEY);
}

export const useNotificationStore = defineStore('notification', () => {

	/** Ringing notifications are hidden */
	const hidden = ref<boolean>(getHiddenFlag());
	const knownRinging:Set<number> = new Set();


	function toggleHidden() {
		hidden.value = !hidden.value;
		setHiddenFlag(hidden.value);
	}

	function receivedBatch(nots: Notification[]) {
		for (let n of nots) {
			if (n.state === 'ring') {
				if (!knownRinging.has(n.id)) {
					hidden.value = false;
					setHiddenFlag(hidden.value);
					knownRinging.add(n.id);
				}
			}
		}
	}

	function setKnownNotifications(nots: Notification[]) {
		knownRinging.clear();
		for (let n of nots) {
			if (n.state === 'ring') knownRinging.add(n.id);
		}
	}

	return {
		hidden,
		toggleHidden,
		setKnownNotifications,
		receivedBatch
	};
});